module.exports = __webpack_public_path__ + "img/IMG_0720.a9f0271f.jpeg";